<template>
  <v-dialog
    v-model="dialog"
    max-width="1280"
    scrollable
    content-class="promo-panoramica-dialog"
  >
    <v-card class="promo-panoramica-card">
      <v-img
        class="promo-panoramica-image"
        aspect-ratio="1.7777778"
        :src="promoPanoramicaImage"
      >
        <div class="promo-panoramica-title-overlay">
          <div class="promo-panoramica-title font-hemi-head">
            Nuova visuale "Panoramica"
          </div>
        </div>
      </v-img>

      <v-card-text class="promo-panoramica-content white--text pa-4">
       <v-alert dense text color="info" class="promo-panoramica-alert">
          <div class="font-hemi-head promo-panoramica-subtitle">Panoramica di tutte le rose, svincolati, pianificazione e chat in una unica visuale personalizzabile.</div>

            <div> <v-icon small class="mr-1 info--text" >info</v-icon>Per attivarla/disattivarla premi  <v-btn
            color="navy lighten-2"
            class="white--text mx-2"
            fab
            x-small
            @click="tryNow"
          ><v-icon >view_module</v-icon>
          </v-btn> nella toolbar in alto a destra.</div>
           <!-- <div><v-icon small class="mr-1 info--text" >info</v-icon>Disponibile solo per schermi tablet e desktop</div> -->

       </v-alert>

      </v-card-text>

      <v-card-actions class="promo-panoramica-actions d-flex flex-column">
        <div class="promo-panoramica-actions-buttons">
          <v-btn
            color="secondary"
            class="font-hemi-head px-8"
            rounded
            large
            @click="tryNow"
          >
            Provala subito
          </v-btn>
          <v-btn
            color="secondary"
            class="font-hemi-head px-8"
            outlined
            rounded
            large
            @click="dismiss"
          >
            Chiudi
          </v-btn>
        </div>

        <v-checkbox
          v-model="dontShowAgain"
          class="promo-panoramica-checkbox"
          dark
          dense
          hide-details
          label="Non mostrare più"
        ></v-checkbox>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vuex from "vuex";
import Constants from "../../js/constants";
import Config from "../../../config-app/config";

export default {
  name: "dialog-promo-panoramica",
  data() {
    return {
      dialog: false,
      dontShowAgain: false,
    };
  },
  mounted() {
    if (localStorage.getItem(Constants.LS_PROMO_PANORAMICA) == "T") {
      return;
    }

    this.$nextTick(() => {
      setTimeout(() => {
        if (this.isLayoutPanoramica) {
          return;
        }

        this.dialog = true;
      }, 800);
    });
  },
  methods: {
    persistDontShowAgain() {
      if (this.dontShowAgain) {
        localStorage.setItem(Constants.LS_PROMO_PANORAMICA, "T");
      }
    },
    dismiss() {
      this.persistDontShowAgain();

      this.dialog = false;
    },
    tryNow() {
      this.persistDontShowAgain();
      this.$store.dispatch("switchLayout", Constants.LAYOUT.PANORAMICA);
      this.dialog = false;
    },
  },
  computed: {
    promoPanoramicaImage() {
      return Config.FIREBASE_HOST + "/static/img/promo-panoramica.png";
    },
    ...Vuex.mapGetters(["is_mobile", "isLayoutPanoramica"]),
  },
};
</script>

<style lang="scss" scoped>
.promo-panoramica-card {
  background: var(--v-navy-darken2);
  color: var(--v-text-base);
  overflow: hidden;
}

.promo-panoramica-image {
  background: var(--v-navy-darken3);
  max-height: 68vh;
  position: relative;
}

.promo-panoramica-title-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 20px 24px 54px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.66) 0%,
    rgba(0, 0, 0, 0.34) 54%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.promo-panoramica-title {
  color: white;
  font-size: 42px;
  line-height: 1.15;
  text-shadow: 0 3px 14px rgba(0, 0, 0, 0.75);
}

.promo-panoramica-alert {
  border: 1px solid rgba(255, 255, 255, 0.12);
  margin-bottom: 8px;
}


.promo-panoramica-checkbox {
  margin-top: 8px;
}

.promo-panoramica-actions {
  align-items: center;
  padding: 0 24px 20px;
}

.promo-panoramica-actions-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}
.promo-panoramica-subtitle{
  font-size: 16px;;
}

@media (max-width: 600px) {
  .promo-panoramica-image {
    max-height: 42vh;
  }

  .promo-panoramica-title-overlay {
    padding: 12px 14px 38px;
  }

  .promo-panoramica-title {
    font-size: 24px;
  }
}
</style>
